import { Button, Col, InputNumber, Row, Space, Switch } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { startUpdateServicio } from "../../../../context/actions/concesionariosActions";
import { useParams } from "react-router";

export const PendientePagoPension = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const [newMontoPagoPension, setNewMontoPagoPension] = useState();

  const { pendientePagoPension, montoPagoPension } = useSelector(
    (state) => state.concesionariosReducer.concesionariosServicio
  );

  useEffect(() => {
    setNewMontoPagoPension(montoPagoPension);
  }, [montoPagoPension]);

  const handleChangePension = (val) =>
    dispatch(startUpdateServicio({ pendientePagoPension: val }, id));

  const handleChangeMonto = (val) => setNewMontoPagoPension(val);

  const handleClick = () =>
    dispatch(
      startUpdateServicio({ montoPagoPension: newMontoPagoPension }, id)
    );

  return (
    <>
      <Row style={{ marginBottom: 10 }}>
        <Col>
          <Space direction="vertical">
            <Switch
              checked={pendientePagoPension}
              onChange={handleChangePension}
              checkedChildren="Si"
              unCheckedChildren="No"
            />
          </Space>
        </Col>
        <Col>
          <div className="label">Pendiente Pago Pensión</div>
        </Col>
      </Row>
      <Row gutter={10}>
        <Col span={20}>
          <div>Monto Pago Pensión</div>
          <InputNumber
            value={newMontoPagoPension}
            onChange={handleChangeMonto}
            style={{ width: "100%" }}
            size="small"
          />
        </Col>
        <Col span={4} style={{ paddingTop: 17 }}>
          <Button onClick={handleClick} size="small" danger>
            Ok
          </Button>
        </Col>
      </Row>
    </>
  );
};
